import { createAction } from '@reduxjs/toolkit';
import { Asset, LoadPackReturn } from '../../api';
import { Loading, LoadingMode } from '../finder/model';
import { PackShape } from './model';

export const assetsChanged = createAction<
  { data: LoadPackReturn; hasNextPage: boolean; scrollHash: string },
  'al/pack/assetsChanged'
>('al/pack/assetsChanged');

export const thumbnailUpdated = createAction<{ assetId: Asset['id']; url: Asset['thumbnail_url'] }>(
  'al/pack/thumbnailUpdated',
);

export const setLoading = createAction<{ loading: Loading }, 'al/pack/setLoading'>(
  'al/pack/setLoading',
);

export const loadPackRequested = createAction<{ mode: LoadingMode }, 'al/pack/loadPackRequested'>(
  'al/pack/loadPackRequested',
);

export const assetsToggled = createAction<
  { add: boolean; assets?: Asset[]; selectAll?: boolean },
  'al/pack/assetsToggled'
>('al/pack/assetsToggled');

export const setInProgress = createAction<
  { ids: Asset['id'][]; inProgress: boolean },
  'al/pack/setInProgress'
>('al/pack/setInProgress');

export const setAllInProgress = createAction<
  { allInProgress: boolean },
  'al/pack/setAllInProgress'
>('al/pack/setAllInProgress');

export const clearPackClicked = createAction<void, 'al/pack/clearPackClicked'>(
  'al/pack/clearPackClicked',
);

export const downloadPackClicked = createAction<void, 'al/pack/downloadPackClicked'>(
  'al/pack/downloadPackClicked',
);

export const setRelatedSharing = createAction<{
  relatedSharing: PackShape['relatedSharing'];
}>('al/pack/setRelatedSharing');

export const saveRelatedSharingClicked = createAction('al/pack/saveRelatedSharingClicked');

export const setRelatedSharingInProgress = createAction<{
  inProgress: boolean;
}>('al/pack/setRelatedSharingInProgress');
